AoPS.Utils.initKeyChain(AoPS, "Contests");

AoPS.Contests = (function (Contests) {
	Contests.Router = Backbone.Router.extend({
		initialize: function (options) {
			this.elements = {};
			this.models = {};
			this.models.master = options.master;
			this.myPage = new AoPS.Page.constructPage("contest");
			this.rootContest = this.models.master.get("rootContest");

			this.route(/(.*)/, this.routeHelperTrafficControl);
		},

		routeHelperTrafficControl: function (arg_string) {
			var sanitized = (arg_string || "").split("#")[0].split("?")[0];
			var args = sanitized ? sanitized.split("/") : [];

			if (
				this.rootContest &&
				args[0] === this.rootContest.get("contest_hash") &&
				args[1] === "portal"
			) {
				this.routeHelperOuter(args);
			} else {
				// We are on the wrong router.
				// Reloading will load it with a different router.
				window.location.reload(true);
			}
		},

		routeHelperOuter: function (args) {
			this.showPortal(args.slice(2));
		},

		showPortal: function (args) {
			var unregistered = this.models.master.get("contests").find(
				_.bind(function (contest) {
					var cpu = contest.computeContestPortalUser();
					if (
						cpu &&
						cpu.get("user_type") === "student" &&
						_.isNull(cpu.get("registered_at"))
					) {
						return true;
					}
					return false;
				}, this)
			);

			if (unregistered) {
				this.showRegistration(unregistered);
			} else {
				var selected = this.models.master
					.get("contests")
					.findWhere({contest_hash: args[0]});
				var selected_cpu = selected
					? selected.computeContestPortalUser()
					: null;
				if (selected_cpu && selected_cpu.get("user_type") === "student") {
					this.showRegistration(selected);
				} else {
					this.showRoot();
				}
			}
		},

		showRegistration: function (contest) {
			var parentContest = contest.computeParentContest() || contest;

			this.myPage.clearPage({remove_modals: false});
			this.myPage.$el.addClass(contest.get("contest_hash"));
			this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestPortalRegistration({
						model: contest,
					});
				}, this),
			});

			Backbone.history.navigate(
				parentContest.get("contest_hash") +
					"/portal/" +
					contest.get("contest_hash"),
				{replace: true, trigger: false}
			);
		},

		showRoot: function () {
			this.myPage.clearPage({remove_modals: false});
			this.myPage.$el.addClass(this.rootContest.get("contest_hash"));
			this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestPortalRoot({
						model: this.rootContest,
					});
				}, this),
			});

			Backbone.history.navigate(
				this.rootContest.get("contest_hash") + "/portal",
				{
					replace: true,
					trigger: false,
				}
			);
		},
	});

	/**
	 * Let's get started!
	 */
	$(window).on("load", function () {
		// Magical refresh
		AoPS.refreshOnBackButtonLoadWithOldData("contest");

		/**
		 * I usually start by building a master model that
		 *  is the air-traffic controller for everything.
		 */
		var contest_master = new AoPS.Contests.Models.Master(),
			my_router;

		/**
		 * Then we build the router.
		 */
		my_router = new Contests.Router({
			master: contest_master,
		});

		/**
		 * In the router, we construct the myPage object that
		 *  controls what we put on the page.  It has
		 *  a master view whose .el element is what we manage
		 *  to control what goes into the DOM.  Here, we add
		 *  that master element to the main-content window.
		 */
		$("#main-content").prepend(my_router.myPage.el);
		/**
		 * And then we press go.
		 */
		Backbone.history.start({pushState: true, root: "contests"});

		$(document).on("click", "a[nav]", function (e) {
			var new_url = $(this).attr("href");
			if (!e.metaKey && !e.ctrlKey && new_url.indexOf("contests") > -1) {
				Backbone.history.navigate(new_url.replace(/^\/contests\/?/, ""), {
					trigger: true,
				});
				e.stopPropagation();
				e.preventDefault();
			}
		});
	});

	return Contests;
})(AoPS.Contests);
